<section class="referral-container container-fluid">
    <div class="referral-top row">
        <div class="col-12 col-md-7 referral-top-left">
            <h1 class="heading-2" translate="cart.referral.credits.title"></h1>
            <p>
                <span translate="cart.referral.credits.info.text"></span>&nbsp;
                <a href="javascript:void(0)" (click)="goToHub()" translate="cart.referral.learn.more"></a>
            </p>
            <h2 class="heading-3" translate="cart.referral.credits.sharelink.title"></h2>
            <div>
                <p class="copy-text" translate="cart.referral.credits.sharelink.info.text"></p>
                <copy-short-url
                class="share-list-url"
                [buttonClass]="'button button-primary'"
                [shareOptions]="shareOptions"
                [showIcon]="false"
                [hideTextMobile]="false"></copy-short-url>
            </div>
        </div>
        <div class="col-12 col-md-5 referral-top-right">
            <div class=" card-group flex-group">
                <div class="group-card">
                    <img class="icon" src="/image-service/ws/imgs/file/3903040/aws/w/0/h/0.img" alt="">
                    <div class="group-details">
                        <div class="heading-3 available-credit">{{referralCreditView.availableEarned | usanacurrency | async}}</div>
                        <div translate="cart.referral.credits.available.credit"></div>
                    </div>
                </div>
                <div class="group-card">
                    <img class="icon" src="/image-service/ws/imgs/file/3903042/aws/w/0/h/0.img" alt="">
                    <div class="group-details">
                        <div class="heading-3">{{referralCreditView.totalReferredOrders}}</div>
                        <div translate="cart.referral.credits.referred.orders"></div>
                    </div>
                </div>
                <div class="group-card">
                    <img class="icon" src="/image-service/ws/imgs/file/3903041/aws/w/0/h/0.img" alt="">
                    <div class="group-details">
                        <div class="heading-3">{{referralCreditView.lifetimeEarned | usanacurrency | async}}</div>
                        <div translate="cart.referral.credits.lifetime.earnings"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-warning" *ngIf="exceededTaxLimitMsg">
        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        <h4 class="heading-6" translate="cart.referral.credits.tax.limit.title"></h4>
        <p>{{exceededTaxLimitMsg}}</p>
        <customer-service [preText]="'cart.referral.customer.service'"></customer-service>
    </div>
    <div class="referral-tables">
        <h2 class="heading-3" translate="cart.referral.credits.details.title"></h2>
        <div *ngIf="referralCreditView.credits?.length == 0">
            <div class="spacer" *ngIf="showSpinner" >
                <usana-spinner [show]="showSpinner"></usana-spinner>
            </div>
            <div *ngIf="!showSpinner">
                <span translate="cart.referral.credits.empty"></span>
            </div>
        </div>

        <ng-container
            *ngIf="!isMobile; then desktop else mobile">
        </ng-container>

        <ng-template #desktop>
            <table class="referral-summary full-table" *ngIf="referralCreditView.credits?.length > 0">
                <thead>
                <tr class="full-width">
                    <th scope="col" translate="cart.referral.credits.details.name"></th>
                    <th scope="col" translate="cart.referral.credits.details.exp.date"></th>
                    <th scope="col" translate="cart.referral.credits.details.referred.orders"></th>
                    <th scope="col" translate="cart.referral.credits.details.available"></th>
                    <th scope="col" translate="cart.referral.credits.details.details"></th>
                </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let referralCredit of referralCreditView.credits; trackBy: trackByFn">
                        <tr class="full-width">
                            <td>{{referralCredit.title | usanadate :'MMMM y' | async}}</td>
                            <td>{{referralCredit.expirationDate | usanadate :'shortDate' | async}}</td>
                            <td>{{referralCredit.creditCount}}</td>
                            <td>{{referralCredit.availableTotal | usanacurrency | async}}</td>
                            <td>
                                <a href="javascript:void(0)" [attr.aria-expanded]="referralCredit == currentReferralCredit" (click)="toggleDetailView(referralCredit)">
                                    <i class="fa-solid" [ngClass]="referralCredit == currentReferralCredit ? 'fa-chevron-up': 'fa-chevron-down'"></i>
                                </a>
                            </td>
                        </tr>
                        <tr *ngIf="referralCredit == currentReferralCredit">
                            <td colspan="5" class="full-width">
                                <table class="referral-detail">
                                    <thead>
                                        <tr>
                                            <th scope="col" translate="cart.referral.credits.details.item.name"></th>
                                            <th scope="col" translate="cart.referral.credits.details.date"></th>
                                            <th scope="col" translate="cart.referral.credits.details.value"></th>
                                            <th scope="col" translate="cart.referral.credits.details.running.total"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let line of referralCredit.lineItems | slice:0:detailsLineItemsMax; trackBy: trackByFn" [ngClass]="{'debit':line.type === 'type.return' || line.type === 'type.debit'}">
                                            <td>{{line.typeDisplay}}</td>
                                            <td>{{line.entryDate | usanadate :'shortDate' | async}}</td>
                                            <td>{{line.amount | usanacurrency | async}}</td>
                                            <td>{{line.amountTotal | usanacurrency | async}}</td>
                                        </tr>
                                        <tr *ngIf="showDetailsLineItemsMsg">
                                            <td colspan="4">
                                                <a class="pull-left" href="javascript:void(0)" [attr.aria-expanded]="referralCredit == currentReferralCredit && showingAllItems"
                                                   (click)="toggleDetailsLineItems(referralCredit)">{{detailsLineItemsMsg}}
                                                    <span class="items-showing">{{detailsLineDetailsShowing}}</span>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </ng-template>

        <ng-template #mobile>
            <table class="referral-summary mobile-table" *ngIf="referralCreditView.credits.length > 0">
                <tbody>
                    <ng-container *ngFor="let referralCredit of referralCreditView.credits; trackBy: trackByFn">
                        <tr>
                            <th scope="row" translate="cart.referral.credits.details.name"></th>
                            <td>{{referralCredit.title | usanadate :'MMMM y' | async}}</td>
                        </tr>
                        <tr>
                            <th scope="row" translate="cart.referral.credits.details.exp.date"></th>
                            <td>{{referralCredit.expirationDate | usanadate :'shortDate' | async}}</td>
                        </tr>
                        <tr>
                            <th scope="row" translate="cart.referral.credits.details.referred.orders"></th>
                            <td>{{referralCredit.creditCount}}</td>
                        </tr>
                        <tr>
                            <th scope="row" translate="cart.referral.credits.details.available"></th>
                            <td>{{referralCredit.availableTotal | usanacurrency | async}}</td>
                        </tr>
                        <tr class="border-row-bottom">
                            <th scope="row" translate="cart.referral.credits.details.details"></th>
                            <td>
                                <a href="javascript:void(0)" [attr.aria-expanded]="referralCredit == currentReferralCredit" (click)="toggleDetailView(referralCredit)">
                                    <i class="fa-solid" [ngClass]="referralCredit == currentReferralCredit? 'fa-chevron-up': 'fa-chevron-down'"></i>
                                </a>
                            </td>
                        </tr>
                        <tr *ngIf="referralCredit == currentReferralCredit">
                            <td colspan="5" class="no-padding">
                                <table class="referral-detail">
                                    <tbody *ngFor="let line of referralCredit.lineItems | slice:0:detailsLineItemsMax; trackBy: trackByFn" [ngClass]="line.type === 'debit'? 'debit':''">
                                        <tr class="detail-row-top">
                                            <th scope="row" translate="cart.referral.credits.details.item.name"></th><td>{{line.typeDisplay}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" translate="cart.referral.credits.details.date"></th><td>{{line.entryDate | usanadate :'shortDate' | async}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" translate="cart.referral.credits.details.value"></th><td>{{line.amount | usanacurrency | async}}</td>
                                        </tr>
                                        <tr class="border-row-bottom">
                                            <th scope="row" translate="cart.referral.credits.details.running.total"></th><td>{{line.amountTotal | usanacurrency | async}}</td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="showDetailsLineItemsMsg" class="border-row-bottom">
                                            <td colspan="2" class="more-link">
                                                <a class="pull-left" href="javascript:void(0)" [attr.aria-expanded]="showDetailsLineItemsMsg" (click)="toggleDetailsLineItems(referralCredit)">{{detailsLineItemsMsg}}
                                                    <span class="items-showing">{{detailsLineDetailsShowing}}</span>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </ng-template>
    </div>

    <div class="faq-container">
        <h2 class="heading-2" translate="cart.referral.credits.faq"></h2>

        <h3 class="heading-3" translate="cart.referral.credits.faq.question.one"></h3>
        <p translate="cart.referral.credits.faq.answer.one"></p>

        <h3 class="heading-3" translate="cart.referral.credits.faq.question.two"></h3>
        <p translate="cart.referral.credits.faq.answer.two"></p>

        <h3 class="heading-3" translate="cart.referral.credits.faq.question.three"></h3>
        <p translate="cart.referral.credits.faq.answer.three"></p>

        <p class="faq-more"><span translate="cart.referral.credits.faq.more.questions"></span>&nbsp;
            <a href="javascript:void(0)" (click)="goToHub()" translate="cart.referral.learn.more"></a>.
        </p>
    </div>
</section>
